import {
  Container,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import NavigationHeader from "../../../components/NavigationHeader";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import { FuelCardType } from "./types";
import { Loading } from "../../../components/Loading";
import FuelCardActionModal from "./FuelCardActionModal";
import { tableCellStyles, tableHeaderStyles } from "../../../utils/styles";
import { fuelCardApiService } from "./apiService";
import { formatVehicleNumber } from "../../../utils/utils";

const FuelCard = () => {
  const [fuelCard, setFuelCard] = useState<FuelCardType[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedFuelCard, setSelectedFuelCard] = useState<FuelCardType | null>(
    null
  );

  const fetchFuelCard = async () => {
    setIsLoading(true);
    const fuelCardData = await fuelCardApiService.getFuelCard();
    setFuelCard(fuelCardData);
    setIsLoading(false);
  };

  const handleEditFuelCard = (fuelCard: FuelCardType) => {
    setSelectedFuelCard(fuelCard);
    setOpen(true);
  };

  useEffect(() => {
    fetchFuelCard();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <NavigationHeader
        breadcrumbs={[
          { label: "Master Data", path: "/master-data" },
          { label: "Fuel Card" },
        ]}
        title="Fuel Card"
        button={{
          label: "Add Fuel Card",
          onClick: () => setOpen(true),
          icon: <AddIcon />,
        }}
      />
      {isLoading ? (
        <Loading message="Loading fuel card data..." />
      ) : fuelCard?.length === 0 ? (
        <Typography variant="body1" sx={{ textAlign: "center", mt: 4 }}>
          No fuel card data found
        </Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table size="small" aria-label="fuel card table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ ...tableHeaderStyles }}>
                  Account Number
                </TableCell>
                <TableCell sx={{ ...tableHeaderStyles }}>
                  Vehicle Number
                </TableCell>
                <TableCell sx={{ ...tableHeaderStyles }}>Provider</TableCell>
                <TableCell sx={{ ...tableHeaderStyles }}>Location</TableCell>
                <TableCell sx={{ ...tableHeaderStyles }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fuelCard.map((fuelCard) => (
                <TableRow key={fuelCard.id}>
                  <TableCell sx={{ ...tableCellStyles }}>
                    {fuelCard.accountNumber}
                  </TableCell>
                  <TableCell sx={{ ...tableCellStyles }}>
                    {formatVehicleNumber(fuelCard.vehicleNumber)}
                  </TableCell>
                  <TableCell sx={{ ...tableCellStyles }}>
                    {fuelCard.provider}
                  </TableCell>
                  <TableCell sx={{ ...tableCellStyles }}>
                    {fuelCard.location}
                  </TableCell>
                  <TableCell sx={{ ...tableCellStyles }}>
                    <IconButton onClick={() => handleEditFuelCard(fuelCard)}>
                      <EditIcon sx={{ fontSize: tableCellStyles.fontSize }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <FuelCardActionModal
        open={open}
        onClose={() => setOpen(false)}
        fuelCard={selectedFuelCard}
        isEdit={selectedFuelCard !== null}
        onSuccess={() => {
          fetchFuelCard();
          setOpen(false);
        }}
      />
    </Container>
  );
};

export default FuelCard;
